"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RegistrationTableItemDto = /** @class */ (function () {
    function RegistrationTableItemDto() {
    }
    return RegistrationTableItemDto;
}());
exports.default = RegistrationTableItemDto;
